import React from "react";

interface NavbarPCDropdownItemProps {
    children?: React.ReactNode;
    onClick?: () => void;
}

export function NavbarPCDropdownItem({ children, onClick }: NavbarPCDropdownItemProps ){
    return (
        <li>
            <span className="cursor-pointer dropdown-item d-flex align-items-center" onClick={onClick}>
                {children}
            </span>
        </li>
    );
}